import { render } from "./warning-triangle.vue?vue&type=template&id=089735a4"
import script from "./warning-triangle.vue?vue&type=script&lang=js"
export * from "./warning-triangle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__